var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSommerlueftung(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "16.9333mm",
    height: "13.5481mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 258 206",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_x0020_-_x0020_Sommerl\\xFCftung"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#28AAE1",
    points: "192,170 65,170 65,33 192,33 "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "white",
    strokeWidth: 10.7533,
    x1: 192,
    y1: 108,
    x2: 248,
    y2: 103
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "white",
    strokeWidth: 10.7533,
    points: "192,37 253,8 253,198 192,170 "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "white",
    strokeWidth: 10.7533,
    x1: 66,
    y1: 108,
    x2: 10,
    y2: 103
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "white",
    strokeWidth: 10.7533,
    points: "66,37 5,8 5,198 66,170 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "white",
    strokeWidth: 10.7533,
    points: "192,170 66,170 66,37 192,37 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M144 116c2,-2 2,-5 0,-8l-14 -13c-2,-2 -5,-2 -7,0 -2,2 -2,5 0,7l14 14c2,2 5,2 7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M93 140c3,0 5,-3 5,-6l-2 -19c0,-3 -3,-5 -6,-5 -1,0 -2,1 -3,2 -1,1 -2,2 -2,4l2 19c0,3 3,5 6,5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M66 94c15,7 33,5 47,-9 15,-14 16,-33 9,-48l-56 0 0 57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M163 59l-19 -2c-2,0 -3,1 -4,2 -1,1 -2,2 -2,3 0,3 2,6 5,6l19 2c3,0 6,-2 6,-5 0,-3 -2,-6 -5,-6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSommerlueftung);
export default __webpack_public_path__ + "static/media/Sommerlueftung.b5714060a08b3e4efea3a5a6493226de.svg";
export { ForwardRef as ReactComponent };